import { useQuery } from '@tanstack/react-query'
import { chatPodFilterOptions } from '@fireflyhealth/api'

interface PodFilterOption {
  name: string
  id: number
}

const getPodFilterOptions = async (): Promise<PodFilterOption[]> => {
  const { data } = await chatPodFilterOptions.list()
  return data
}

const usePodFilterOptions = () => {
  const { data: podFilterOptions } = useQuery({
    queryKey: ['podFilterOptions'],
    queryFn: getPodFilterOptions,
    staleTime: Infinity,
  })
  return podFilterOptions ?? []
}

export { usePodFilterOptions }
